module.exports = __webpack_public_path__ + "img/header-cancel-icon.129e5d3b.png";